import { OCTBDashboardMixerApi } from '@linktivity/octb-dashboard';
import config from '../config';

const OCTBDashboardApi = new OCTBDashboardMixerApi(config);

export default OCTBDashboardApi;
